import { createFileRoute } from '@tanstack/react-router'
import { NotFound } from '../common/components/404'

// Catch-all so unmatched paths still render inside the nav chrome
export const Route = createFileRoute('/_a/$')({
  component: NotFound,
})
